const openPopupMock = () => (_externalId, onClose) => {
  onClose();
  return [];
};

export default openPopupMock;
